import { cn } from '@/utils/tailwind/utils'
import { FC } from 'react'

type Props = {
  className?: string
}

const LoadingDots: FC<Props> = ({ className }) => {
  return (
    <div className={cn('inline-block text-center loading-dots', className)}>
      <span />
    </div>
  )
}

export default LoadingDots
